"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BooleanNode = void 0;
const DataModel_1 = require("../model/DataModel");
const Node_1 = require("./Node");
/**
 * Boolean node with two buttons for true/false
 */
const BooleanNode = () => {
    return {
        ...Node_1.Base,
        type: () => 'boolean',
        default: () => false,
        suggest: () => ['false', 'true'],
        validate(path, value, errors, options) {
            if (options.loose && typeof value !== 'boolean') {
                value = options.wrapLists ? DataModel_1.DataModel.wrapLists(this.default()) : this.default();
            }
            if (typeof value !== 'boolean' || value === undefined) {
                errors.add(path, 'error.expected_boolean');
            }
            return value;
        },
        hook(hook, path, ...args) {
            var _a;
            return ((_a = hook.boolean) !== null && _a !== void 0 ? _a : hook.base).call(hook, { node: this }, path, ...args);
        }
    };
};
exports.BooleanNode = BooleanNode;
